import styled from 'styled-components'

export const Container = styled.div`
    max-width: 100%; // 245
    height: 150px;
    border-radius: 8px;
    padding: 44px 24px;

    display: flex;
    justify-content: space-between;
    transition: 0.2s ease-out;
    cursor: pointer;

    &:hover { 
        transform: scale(1.02);
        transition: 0.2s ease-out;

    }


`;

export const Title = styled.div`
    color: #FFFFFF;
    margin-right: 20px;
    display: flex;

    h5 { 
        font-size: 20px;
        font-weight: bold;
        align-self: center;
    }
`;
